export default "__VITE_ASSET__BLiKboQa__"